import { render, staticRenderFns } from "./data_view.vue?vue&type=template&id=163ae1e8&scoped=true&"
import script from "./data_view.vue?vue&type=script&lang=ts&"
export * from "./data_view.vue?vue&type=script&lang=ts&"
import style0 from "./data_view.vue?vue&type=style&index=0&id=163ae1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ae1e8",
  null
  
)

export default component.exports